"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PINMessageState = exports.PINMessageSender = exports.PINMessageData = void 0;
/**
 * @description Used to control senders.
 */
var PINMessageSender;
(function (PINMessageSender) {
    PINMessageSender["Operator"] = "sender-operator";
    PINMessageSender["Lead"] = "sender-lead";
})(PINMessageSender || (PINMessageSender = {}));
exports.PINMessageSender = PINMessageSender;
/**
 * @description Used to describe the message's state.
 */
var PINMessageState;
(function (PINMessageState) {
    PINMessageState["Sending"] = "sending";
    PINMessageState["Error"] = "error";
    PINMessageState["Sent"] = "sent";
})(PINMessageState || (PINMessageState = {}));
exports.PINMessageState = PINMessageState;
/**
 * @description Used to drive PINChatBubbles.
 * @param text Text of the message
 * @param received Unix Timestamp of the message
 * @param sender Optional, either Operator or Lead. See [[PINMessageSender]]
 * @param state describe the message's state. See [[PINMessageState]]
 */
var PINMessageData = /** @class */ (function () {
    /**
     * @param text Text of the message
     * @param received Unix Timestamp of the message
     * @param sender Optional, either Operator or Lead. Operator
     * @param state describe the message's state
     */
    function PINMessageData(text, received, sender, state) {
        if (state === void 0) { state = PINMessageState.Sent; }
        this.text = text;
        this.received = received;
        // @ts-expect-error ts-migrate(2322) FIXME: Type 'PINMessageSender | undefined' is not assigna... Remove this comment to see the full error message
        this.sender = sender || undefined;
        this.state = state;
    }
    /**
     * @description Set the sender incoming from smooch. Fallback is [[PINMessageSender.Lead]]
     * @param smoochSender
     */
    PINMessageData.prototype.setSenderFromSmooch = function (smoochSender) {
        var map = {
            app: PINMessageSender.Operator,
            appMaker: PINMessageSender.Operator,
            appUser: PINMessageSender.Lead
        };
        // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        this.sender = map[smoochSender] || PINMessageSender.Lead;
    };
    /**
     * @returns the localized key corresponded to the message's state
     */
    PINMessageData.prototype.formattedStateKey = function () {
        return "message.data.state." + this.state;
    };
    return PINMessageData;
}());
exports.PINMessageData = PINMessageData;
//# sourceMappingURL=PINMessageData.js.map